import styled from 'styled-components';

interface IconButtonProps {
  disabled?: boolean;
}

export const IconButton = styled.button<IconButtonProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  &:focus-visible {
    outline: none;
  }

  &::-moz-focus-inner {
    border: 0;
  }
`;
